"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.default = styled_components_1.default.div `
  display: flex;
  height: 0;
  justify-content: center;
  overflow: hidden;
  width: 100%;

  @media ${config_1.device.laptop} {
    height: 100%;
    min-height: 800px;
    width: 60%;
  }
`;
